import Image from "_components/atoms/image";

import useStyles from "./styles/Avatar";

const Avatar = ( { sportsFanId, photo } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	{ /* const onClickImageHandler = () => {
		const isOwnProfile = data.sportsFan.id === userProfile.id;

		if ( isOwnProfile ) return;

		router.push ( `/profile/${ data.sportsFan.id }` );
	}; */ }

	return (
		<div>
			<a
				className = { classes.anchorTag }
				href = { `/profile/${ sportsFanId }` }
				rel = "noreferrer"
				target = "_blank"
			>
				<Image
					alt = ""
					className = { classes.avatarImage }
					// onClick = { onClickImageHandler }
					src = { photo }
					type = "xldpi"
				/>
			</a>
		</div>
	);
};

export default Avatar;
